import React, { Component } from 'react';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import Icon from '../Icon';
import Comments from '../Comments/';
import ElementProperties from '../ElementProperties';
import InlineEditor from '../types/InlineEditor';
import String from '../types/String';
import DropDownButton from '../ui/DropDownButton';
import ActivityFeed from '../ActivityFeed';
import IssuesTab from '../IssuesTab';
import '../../styles/Element.css';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTimesCircle from '@fortawesome/fontawesome-pro-light/faTimesCircle';
import faExclamationSquare from '@fortawesome/fontawesome-pro-light/faExclamationSquare';
import faBars from '@fortawesome/fontawesome-pro-light/faBars';
import faInfoCircle from '@fortawesome/fontawesome-pro-light/faInfoCircle';
import faList from '@fortawesome/fontawesome-pro-light/faList';
import faComment from '@fortawesome/fontawesome-pro-light/faComment';

export default class StandardElement extends Component {
  static propTypes = {
    element: PropTypes.instanceOf(Map),
    icon: PropTypes.object,
    currentElementType: PropTypes.object,
    currentUser: PropTypes.instanceOf(Map),
    toggleSelectIconModal: PropTypes.func,
    selectElement: PropTypes.func,
    userMode: PropTypes.string,
    confirmDelete: PropTypes.func,
    onSave: PropTypes.func,
    currentElementId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      adminMode: props.userMode !== 'user' && props.userMode !== 'reader',
      currentTab: 'props',
    };
  }

  componentDidMount() {
    const { rootElement, dispatch, element } = this.props;
    if (rootElement) {
      dispatch(push(`/project/${element.get('project_id')}`));
    }
  }

  setTabState = (e) => {
    this.setState({
      currentTab: e.target.id,
    });
  }

  _toggleSelectIconModal = () => {
    const { toggleSelectIconModal, element } = this.props;

    const elementId = element.get('id');

    toggleSelectIconModal(elementId);
  };

  _confirmDelete = () => {
    const { confirmDelete } = this.props;

    confirmDelete();
  };

  _onSave = value => {
    const { onSave, currentElementId } = this.props;

    const formUid = `element_${currentElementId}`;

    onSave(value, formUid);
  };

  _selectElement = () => {
    const { selectElement } = this.props;

    selectElement(-1);
  };

  renderCloseButton = show => {
    return show
      ? <FontAwesomeIcon style={{ verticalAlign: 'middle', cursor: 'pointer' }} onClick={this._selectElement} size="1x" icon={faTimesCircle} />
    : null;
  };

  renderAdminDropdown = show => {
    return show
      ? <DropDownButton
        id="quick-add-btn"
        icon={faBars}
        className={'element-dropdown'}
        title=""
        styleOverrides={{
          background: '#fff',
        }}
        hideToggle={true}
      >
        <a
          id="quick-add-element"
          className="dropdown-item"
          onClick={this._confirmDelete}
        >
          Delete
        </a>
      </DropDownButton>
    : null;
  };

  renderTab = () => {
    const {
      element,
      currentElementType,
      currentUser,
      userMode,
    } = this.props;

    const {
      currentTab,
    } = this.state;

    switch (currentTab) {
      case 'activities':
        return (
          <ActivityFeed
            type="element"
            projectId={element.get('project_id')}
            id={element.get('id')}
            currentUser={currentUser}
            loadAll={false}
            style={{ flexGrow: 1 }}
          />
        );
      case 'comments':
        return (
          currentElementType.hasIn(['props', 'Comments']) &&
            <Comments
              type="Element"
              id={element.get('id')}
              projectId={element.get('project_id')}
              currentUser={currentUser}
            />
        );
      case 'issues':
        return (
          <IssuesTab
            id={element.get('id')}
            projectId={element.get('project_id')}
          />
        );
      case 'props':
      default:
        return <ElementProperties element={element} userMode={userMode} />;
    }
  }

  render() {
    const {
      element,
      currentElementId,
      icon,
      selectElement,
      userMode,
    } = this.props;

    const {
      adminMode,
      currentTab,
    } = this.state;
    const elementName = element.get('name');

    return (
      <div className="tab-content">
        <section className="elementTitle" style={{ position: 'relative' }}>
          <div style={{ float: 'right', marginTop: -5 }}>
            {this.renderAdminDropdown(adminMode)}
            {this.renderCloseButton(selectElement)}
          </div>
          <h2>
            <Icon
              icon={icon}
              toggleSelectIconModal={this._toggleSelectIconModal}
              pageType="element"
            />
            <InlineEditor
              component={String}
              style={{ display: 'inline' }}
              value={elementName}
              form={`element_${currentElementId}`}
              onSave={this._onSave}
              userMode={userMode}
            />
          </h2>
        </section>
        <div style={{ display: 'flex', flexDirection: 'row', background: '#e6eced', marginTop: '1.5rem', color: 'gray' }}>
          <div id="props" onClick={this.setTabState} style={{ padding: '10px 30px', background: currentTab === 'props' ? 'rgb(14, 65, 81)' : '#e6eced', color: currentTab === 'props' ? '#fff' : '#0e4151', cursor: 'pointer' }}>
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '1.5em', 'pointer-events': 'none' }} size="2x" icon={faInfoCircle} />
          </div>
          <div id="activities" onClick={this.setTabState} style={{ padding: '10px 30px', background: currentTab === 'activities' ? 'rgb(14, 65, 81)' : '#e6eced', color: currentTab === 'activities' ? '#fff' : '#0e4151', cursor: 'pointer' }}>
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '1.5em', 'pointer-events': 'none' }} size="2x" icon={faList} />
          </div>
          <div id="comments" onClick={this.setTabState} style={{ padding: '10px 30px', background: currentTab === 'comments' ? 'rgb(14, 65, 81)' : '#e6eced', color: currentTab === 'comments' ? '#fff' : '#0e4151', cursor: 'pointer' }}>
            <FontAwesomeIcon style={{ verticalAlign: 'middle', fontSize: '1.5em', 'pointer-events': 'none' }} size="2x" icon={faComment} />
          </div>
          {/* <div style={{ padding: '10px 30px', background: currentTab === 'issues' ? 'rgb(14, 65, 81)' : '#e6eced', color: currentTab === 'issues' ? '#fff' : '#0e4151', cursor: 'pointer' }}>
            <FontAwesomeIcon id="issues" onClick={this.setTabState} style={{ verticalAlign: 'middle', fontSize: '1.5em' }} size="2x" icon={faExclamationSquare} />
          </div> */}
        </div>
        {this.renderTab(currentTab)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StandardElement/StandardElement.js